import { render, staticRenderFns } from "./EditTerminalToTerminal.vue?vue&type=template&id=63b99058"
import script from "./EditTerminalToTerminal.vue?vue&type=script&lang=js"
export * from "./EditTerminalToTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports